import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { api } from "../../../utils/axios/Config";
import Buttons from "../../Buttons";
import Pagination from "../../Pagination";
import Loader from "../../shared/Loader";
import Hint from "../Hint";
import SettlementsCard from "./SettlementsCard";
import SettlementsRows from "./SettlementsRows";

const Settlements = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const walletId = useSelector((store) => store.bussinessSlice.data?.business?.wallet_id);

  const pageSize = 20;

  const handleNewAccount = useCallback(() => navigate("/settlement/new"), [navigate]);

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/wallets/settlements/?wallet_id=${walletId}&limit=${pageSize}&offset=${
          (currentPage - 1) * pageSize
        }`,
      );
      setData(response.data.items);
      setTotalCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [walletId, pageSize, currentPage]);

  useEffect(() => {
    let isCancelled = false;
    const safeFetchData = async () => {
      if (!isCancelled) {
        await fetchData();
      }
    };

    safeFetchData();

    return () => {
      isCancelled = true;
    };
  }, [fetchData]);

  if (isLoading) {
    return (
      <div className="w-full h-full flex-center">
        <Loader />
      </div>
    );
  }
  return (
    <>
      {true ? (
        <div className="w-full">
          <div className="w-full flex flex-col items-end  p-1 md:p-6 rounded-v-lg">
            <div className="w-full flex justify-between items-center my-2">
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"تسویه جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </div>

            <div className="w-full mt-4 hidden md:block bg-neutral-00  p-2 h-full ">
              <div className="w-full grid grid-cols-[.25fr_1fr_1fr_1fr_1fr] py-4 whitespace-nowrap text-neutral-40 mt-2 px-2 text-title-sm-regular">
                <div className="text-center">شناسه تسویه</div>
                <div className="text-center">شبای مقصد</div>
                <div className="text-center">مبلغ تسویه(ریال)</div>
                <div className="text-center">تاریخ درخواست</div>
                <div className="text-center">وضعیت تسویه</div>
              </div>
              <hr className="bg-neutral-20 w-full h-1 mb-2" />

              <div className="w-full">
                {data.length ? (
                  data.map((item, index) => <SettlementsRows key={index} rowData={item} index={index} />)
                ) : (
                  <p>آیتمی وجود ندارد ...</p>
                )}
              </div>
            </div>
            <div className="w-full bg-neutral-20 p-2 grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 md:p-2 rounded-[16px]  md:hidden  ">
              {data.length > 0 ? (
                data.map((item, index) => <SettlementsCard key={index} item={item} navigate={navigate} />)
              ) : (
                <p>آیتمی وجود ندارد ...</p>
              )}
            </div>
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg  md:pb-[100px]">
            <Pagination
              onPageChange={onPageChange}
              totalCount={totalCount}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="flex h-full justify-center items-center w-full">
          <Hint
            hintStyle={"entry"}
            response={"mobile"}
            hintImage={true}
            title={"به بخش درگاه ها خوش آمدید!"}
            entry={"flex justify-center items-center"}
          >
            <p className="flex justify-center items-center mb-4">
              هنوز درگاه ایجاد نشده است. برای افزودن اولین درگاه، کافی است بر روی دکمه زیر کلیک
              <br /> نمایید و ادامه فرایند را طی کنید.
            </p>
            <div onClick={handleNewAccount}>
              <Buttons
                btnStyleparam={"mainbutton"}
                fontsize={"dashboard"}
                bgcolor={"primary"}
                txtcolor={"primary"}
                children={"افزودن درگاه جدید"}
                lefticon={false}
                righticon={false}
                borders={"secondary"}
                bRadius={"xl"}
              />
            </div>
          </Hint>
        </div>
      )}
    </>
  );
};

export default Settlements;
